import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { DataService_discipline } from "../../../../../student/discipline/shared/data.service";
import { wsDisciplineGuidInfo } from "../../../../../student/discipline/shared/ws-discipline-info";

@Component({
	selector: "app-group-action-comment",
	templateUrl: "./group-action-comment.component.html",
	styleUrls: ["./group-action-comment.component.css"],
})
export class GroupActionCommentComponent implements OnInit {
	constructor(
		private dataService: DataService_discipline,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public rIncidentImageID: string = "";
	public rIncidentImageTitle: string = "";
	public rIncidentImageComment: string = "";

	public GuidData: wsDisciplineGuidInfo;

	public response: any = {
		isSave: false,
		IncidentImageID: "",
		IncidentImageTitle: "",
		IncidentImageComment: "",
	};

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.rIncidentImageID = this.dialogConfig.data.IncidentImageID;
		this.rIncidentImageTitle = this.dialogConfig.data.IncidentImageTitle;
		this.rIncidentImageComment = this.dialogConfig.data.IncidentImageComment;

		if (this.rIncidentImageID.length == 0) {
			this.isBusy = true;
			this.dataService.CreateGUID().subscribe((data) => this.CreateGUID_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	CreateGUID_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	CreateGUID_Complete(data: any) {
		this.GuidData = data;
		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onAddUpdate() {
		this.ErrorMessage = "";

		//
		// Validate Message
		//
		if (this.rIncidentImageTitle.length < 1) {
			this.ErrorMessage = "Title must be entered.";
			return;
		}

		if (this.rIncidentImageComment.length < 1) {
			this.ErrorMessage = "Comment must be entered.";
			return;
		}

		//
		//	SAVE
		//
		if (this.ErrorMessage.length == 0) {
			if (this.rIncidentImageID.length == 0) {
				// Add
				this.response.IncidentImageID = this.GuidData.NEWID;
			} else {
				// Update
				this.response.IncidentImageID = this.rIncidentImageID;
			}

			this.response.isSave = true;
			this.response.IncidentImageTitle = this.rIncidentImageTitle;
			this.response.IncidentImageComment = this.rIncidentImageComment;

			this.ref.close(this.response);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		//	CANCEL
		//
		this.response.isSave = false;

		this.ref.close(this.response);
	}
}
